//import { Card, CardTitle } from "../components/Card";

export default function ContactUs() {
  return (
    <h1>Contact Us</h1>
  );
}